export default function () {
  return {
    account: {}
  };
}
